
import { Action } from 'redux';
import { CheckoutActionTypes } from '../../checkout.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface ClearFinanceDataAction extends Action<CheckoutActionTypes.CLEAR_FINANCE_DATA> {
}

export const clearFinanceData: () => ClearFinanceDataAction = () => ({
    type: CheckoutActionTypes.CLEAR_FINANCE_DATA
});
clearFinanceData[ACTION_CREATOR_NAME] = 'clearFinanceData';

export type ClearFinanceDataFunc = (...args: Parameters<typeof clearFinanceData>) => void;